// extracted by mini-css-extract-plugin
export default {"BlogsPage":"style_BlogsPage__55Ru2"};